import { formatCurrency } from "~/utils/currency/format-currency";

export const getPriceFilterLabel = (
  stringifiedObject: string,
  locale: string,
  currency: string,
  overText: string,
): string => {
  const filterObject = JSON.parse(stringifiedObject);
  // Price comes in pennies and need be transformed to pounds
  const start = filterObject.start / 100;
  const end = filterObject.end / 100;
  return filterObject.end
    ? `${formatCurrency(locale, currency, start, 0)} - ${formatCurrency(locale, currency, end, 0)}`
    : `${overText} ${formatCurrency(locale, currency, start, 0)}`;
};
